import classnames from 'classnames'

import { ComponentTheme } from '~/components/themes'

import type { IconTypes } from '../Icon/Icon'
import { Icon } from '../Icon/Icon'
import Text, { TextSizes } from '../Text/Text'

import styles from './Stat.module.css'

export interface StatProps {
  number: string
  text: string
  className?: string
  icon?: IconTypes
  theme?: ComponentTheme
  testID?: string
}

export default function Stat({
  number,
  text,
  className,
  icon,
  theme,
  testID,
}: StatProps) {
  const isVariant = theme === ComponentTheme.black
  return (
    <div
      className={classnames(
        styles.base,
        className && className,
        theme && styles[theme]
      )}
      data-testid={testID}
    >
      {icon && (
        <div
          className={classnames(styles.iconContainer, styles[`icon${icon}`])}
        >
          <Icon type={icon} responsive={true} />
        </div>
      )}
      <Text
        Tag="p"
        size={
          !isVariant
            ? TextSizes.primaryTitleLrgPlus
            : TextSizes.secondaryTitleLrg
        }
        className={styles.statNumber}
      >
        {number}
      </Text>

      <Text
        Tag="p"
        size={!isVariant ? TextSizes.bodyMed : TextSizes.primaryTitleSml}
        weight={!isVariant ? 'light' : undefined}
        className={styles.statText}
        uppercase={true}
      >
        {text}
      </Text>
    </div>
  )
}
